import { render, staticRenderFns } from "./ItemSancionPopUp.vue?vue&type=template&id=65a08c26&"
import script from "./ItemSancionPopUp.vue?vue&type=script&lang=js&"
export * from "./ItemSancionPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports